import _ from "lodash";
import TableReportHelper from "report/helper";

export default function apontamentoObservacaoReport(visita, indicador, apontamento) {
    if (_.isEmpty(apontamento.observacao)) {
        return null;
    }

    const h = new TableReportHelper(apontamento);

    return [
        h.panel([
            // prettier-ignore
            h.row(
                h.title("Observação da Amostra")
            ),

            // prettier-ignore
            h.row(
                h.textField("observacao", {alignment: 'justify'})
            ),
        ]),
    ];
}
